import { useAppDispatch, useAppSelector } from "../../../../app/redux/hooks";
import InfoIcon from "@mui/icons-material/Info";
import { setStepperActiveMenu } from "../../../../app/slices/checkoutSlice/CheckoutSlice";
import { useNavigate } from "react-router-dom";
import {
  cartFlushAsync,
  fetchCartListAsync,
} from "../../../../app/slices/cartSlice/CartSlice";
import {
  setLocationAsync,
  setLocationVerifiedStatus,
} from "../../../../app/slices/common/locationSlice/locationSlice";
import { showSnackbar } from "../../../../app/slices/common/customSnackBar/customSnackbarSlice";
import { getDecryptedToken } from "../../../../app/auth/authHandler";
import { useState } from "react";
import { CircularProgress } from "@mui/material";

export const LocationConfirmationPrompt = ({
  onClose,
  onModalCloseCallback,
  isFromCheckout,
  isDeliveryChargeChangeOnly = false,
  message = null,
  address,
}: any) => {
  const dispatch = useAppDispatch();
  const { profileData }: any = useAppSelector((state) => state.ProfileState);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const handleRetainLocation = () => {
    // const active: any = "deliveryInfo";
    // dispatch(setStepperActiveMenu(active));
    onClose();
  };
  const handleChangeLocation = () => {
    setLoading(true);
    let payload: any = {};
    const aId = localStorage.getItem("aId");
    const accessToken = getDecryptedToken();

    if (aId && accessToken === null) {
      payload.anonymous_id = aId;
    }
    if (!isDeliveryChargeChangeOnly) {
      dispatch(cartFlushAsync(payload)).then((response: any) => {
        if (response?.payload?.status === 200) {
          const anonymous_id = accessToken ? null : aId ? aId : null;
          dispatch(fetchCartListAsync(anonymous_id));
        }
      });
    }

    if (isFromCheckout) {
      let payload: any = {
        latitude: Number(address?.latitude),
        longitude: Number(address?.longitude),
        address_id: Number(address?.id),
      };
      dispatch(setLocationAsync(payload)).then((response: any) => {
        if (response?.payload?.data?.location) {
          setLoading(false);
          dispatch(setLocationVerifiedStatus("success"));
          if (!isDeliveryChargeChangeOnly) {
            window.location.href = "/shopnow/";
          } else {
            window.location.reload();
          }
          // onCloseModal();
          dispatch(
            showSnackbar({
              message: "Location added successfully",
              severity: "success",
              autoHide: 3000,
            }),
          );
        } else {
          setLoading(false);
          dispatch(
            showSnackbar({
              message: "Please try again later.",
              severity: "error",
              autoHide: 3000,
            }),
          );
        }
      });
      if (!isDeliveryChargeChangeOnly) {
        navigate("/");
      }
    }
    onModalCloseCallback("confirmed");
    onClose();
  };
  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(255,255,255,0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
          }}
        >
          <CircularProgress color="success" />
        </div>
      )}
      <div
        style={{
          fontFamily: "Albert Sans, sans-serif",
          fontSize: "14px",
          lineHeight: "22px",
          fontWeight: 400,
          color: "var(--main)",
          backgroundColor: "var(--white)",
        }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content text-center">
            <img
              src="/shopnow/images/location-change.svg"
              alt=""
              style={{
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
                width: "40%",
              }}
            />
            <div className="header mb-2 text-center">
              <div
                className="demo-title"
                style={{
                  width: "100%",
                  textAlign: "center",
                }}
              >
                <h6 style={{ margin: 0 }}>Confirm Delivery Location</h6>
              </div>
            </div>
            <div className="tf-login-form">
              <form className="">
                <div className="mb-3 mt-0">
                  <p className="address-text">
                    Hey{" "}
                    {/* {profileData?.data?.first_name
                      ? profileData?.data?.first_name
                      : profileData?.data?.phone_number} */}
                    ! 😊
                  </p>
                  <p className="address-text">
                    {message ||
                      `Changing your location will clear your current cart, as
                    items may vary by location.`}
                  </p>
                  {/* <p className="address-text"> Would you like to proceed?</p> */}
                </div>
                <div className="bottom">
                  <div>
                    <a className="btn-second" onClick={handleChangeLocation}>
                      Change Location
                    </a>
                    <a className="btn-prime" onClick={handleRetainLocation}>
                      Retain Location
                    </a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
